// src/components/ConfirmationModal/ConfirmationModal.js

import React from 'react';
import PropTypes from 'prop-types';
import styles from './ConfirmationModal.module.css';
import { FaTimes, FaExclamationTriangle, FaCheck, FaBan } from 'react-icons/fa';

const ConfirmationModal = ({ isOpen, onClose, onConfirm = () => {}, message, title = "Confirm Action" }) => {
  if (!isOpen) return null;

  return (
    <div
      className={styles.modalOverlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirmationTitle"
      onClick={(e) => {
        // Close modal when clicking overlay
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={styles.modalContent}>
        {/* Modal Header */}
        <div className={styles.modalHeader}>
          <h3 id="confirmationTitle">
            <FaExclamationTriangle className={styles.warningIcon} />
            {title}
          </h3>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close Confirmation Modal"
          >
            <FaTimes />
          </button>
        </div>

        {/* Modal Body */}
        <div className={styles.modalBody}>
          <p>{message}</p>
        </div>

        {/* Modal Actions */}
        <div className={styles.modalActions}>
          <button
            onClick={onClose}
            className={`${styles.button} ${styles.cancelButton}`}
          >
            <FaBan />
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`${styles.button} ${styles.confirmButton}`}
          >
            <FaCheck />
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default ConfirmationModal;
